import { render, staticRenderFns } from "./InformesIndex.vue?vue&type=template&id=59a7ca60&"
import script from "./InformesIndex.vue?vue&type=script&lang=js&"
export * from "./InformesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports